class BrowserFallback {
  constructor() {
    this.safariVersion = '14';
  }

  init() {
    const browser = this.getBrowser();

    if (browser.name === 'Safari' && browser.version === this.safariVersion) {
      this.adjustHeroTrapezoidForSafari14();
    }
  }

  getBrowser() {
    const ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return {name: 'IE', version: tem[1] || ''};
    }

    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);

      if (tem != null) {
        return {name: tem[1].replace('OPR', 'Opera'), version: tem[2]};
      }
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }

    return {name: M[0], version: M[1]};
  }

  adjustHeroTrapezoidForSafari14() {
    const element = document.querySelector('.hero-trapezoid__images');
    element.setAttribute('style', 'grid-template: minmax(150px, 250px) 250px minmax(150px, 550px) / minmax(150px, 250px) minmax(250px, 150px) minmax(300px, 550px);');
  }
}

const browserFallback = {
  init() {
    const browserFallbackElement = new BrowserFallback();
    browserFallbackElement.init();
  },
};

export default browserFallback;
